import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationHelper } from '../../helpers/navigation';
import { AddName } from '../../models/notes/add-name.model';
import { NoteService } from '../../services/note.service';
import { PottyNotesGestureController } from '../../utils/gesture.controller';
import { Router } from '@angular/router';

@Component({
    selector: 'add-name-container',
    templateUrl: 'add-name.html',
    styleUrls: ['add-name.scss'],
    standalone: false
})
export class AddNameContainer implements OnInit {
	public static readonly ComponentIdentifier: number = 0;
	public activeStep = 1;
	public showHintMessage = false;
	public isStartOfFlow: boolean;
	public continueButtonDisabled: boolean;

	name: string;
	remainAnonymous: boolean;

	private initialTouchX: number | null = null;
	private initialTouchY: number | null = null;
	private touchStartTime: number | null = null;

	constructor(private noteService: NoteService,
		private navigationHelper: NavigationHelper,
	    private router: Router) { }

	ngOnInit(): void {
		this.isStartOfFlow = this.navigationHelper.isStartOfNoteFlow();
		this.continueButtonDisabled = true;
		this.remainAnonymous = false;
	}

	public saveNameMetadata(event: Event) {
		this.noteService.setAddName(new AddName(this.name, this.remainAnonymous), this.navigationHelper.skipButtonPressed(event))
	}

	public determineContinueButtonStatus(event: any) {
		// If the event was a boolean, it came from the remain anon checkbox.
		if (typeof event == "boolean") {
			this.setStatusForFormControlsBasedOffAnonymousCheckbox(event);
		} // If someone presses backspace or tries to erase the input box with no characters in it. (Edge case.)
		else if (event == '') {
			this.continueButtonDisabled = true;
		}
		else { // If someone gives us their name.
			this.continueButtonDisabled = false;
			this.remainAnonymous = false;
		}
	}

	public showHint() {
		this.showHintMessage = !this.showHintMessage;
	}

	// This function keys off of what state we were previously in before the click occurred.
	public setStatusForFormControlBasedOffAnonymousText() {
		// If we _were_ anon, reverse the states.
		if (this.remainAnonymous) {
			this.remainAnonymous = false;
			this.continueButtonDisabled = true;
			this.name = "";
		}
		// If we _were not_ anon, reverse the states.
		else {
			this.remainAnonymous = true;
			this.continueButtonDisabled = false;
			this.name = "";
		}
	}

	// This function assumes the event is what we are going to be in.
	private setStatusForFormControlsBasedOffAnonymousCheckbox(event: any) {
		// If we remain anonymous wipe out everything, and let them proceed.
		if (event) {
			this.remainAnonymous = true;
			this.continueButtonDisabled = false;
			this.name = "";
		} // If we don't remain anonymous, check to see if we have a name. If we do, can proceed.
		else if (!event && this.nameIsPopulated()) {
			this.remainAnonymous = false;
			this.continueButtonDisabled = false;
		} // If we dont remain anonymous, check to see if we have a name. If we dont, do not proceed.
		else if (!event && !this.nameIsPopulated()) {
			this.remainAnonymous = false;
			this.continueButtonDisabled = true;
		}
	}

	private nameIsPopulated(): boolean {
		return this.name != undefined && this.name != null && this.name != ""
	}

	// Gesture control 
	@HostListener('touchstart', ['$event'])
	public onTouchStart(event: TouchEvent): void {
		event.stopPropagation();
		this.initialTouchX = event.touches[0].clientX;
		this.initialTouchY = event.touches[0].clientY;
		this.touchStartTime = Date.now();
	}

	@HostListener('touchmove', ['$event'])
	public onTouchMove(event: TouchEvent): void {
		event.stopPropagation();

		if (this.initialTouchX === null || this.touchStartTime === null || this.initialTouchY === null
			|| (!this.nameIsPopulated() && !this.remainAnonymous)) return;

		const currentTouchX = event.touches[0].clientX;
		const currentTouchY = event.touches[0].clientY;
		const deltaX = currentTouchX - this.initialTouchX;
		const deltaY = currentTouchY - this.initialTouchY;
		const timeDiff = Date.now() - this.touchStartTime

		if (PottyNotesGestureController.MovedLeftEnough(timeDiff, deltaX, deltaY)) {
			this.saveNameMetadata(event);
			this.router.navigate([`${this.navigationHelper.getNextComponentUrl()}`]);
		}
	}

	@HostListener('touchend', ['$event'])
	public onTouchEnd(event: TouchEvent): void {
		event.stopPropagation();
	}
}
